import axios from "axios";

export async function getMinimalPersonsDetails() {
    try {
        return await axios.get(`/person/all`);
    } catch (e) {
        console.error(e);
    }
}